import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@pg-env/environment';

interface IChangePassword {
  tokenHash: string;
  newPassword: string;
  confirmNewPassword: string;
}

interface IChangePasswordVerifyCode {
  verificationCode: string;
  tokenHash: string;
  verificationType?: Number;
}

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordService {
  baseURL = environment.identityApiUrl;
  clientId = environment.clientId;

  constructor(private http: HttpClient) { }

  forgotPassword(email: string): Observable<any> {
    const forgotPassword = {
      email: email,
      clientId: this.clientId
    };

    return this.http.post(`${this.baseURL}/account/forgot-password`, forgotPassword);
  }

  validateResetPasswordToken(tokenHash: string): Observable<any> {
    return this.http.get(`${this.baseURL}/account/validate-reset-password-token?tokenHash=${tokenHash}`, {
      headers: {
        useLocalHandleException: 'Y'
      }
    });
  }

  forgotPasswordSendVerificationCode(params: any): Observable<any> {
    return this.http.post(
      `${this.baseURL}/account/forgot-password-send-verification-code`,
      params
    );
  }

  verifyCode(info: IChangePasswordVerifyCode): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/account/forgot-password-verify-code`, info);
  }

  changePassword(changePassword: IChangePassword): Observable<any> {
    return this.http.post(`${this.baseURL}/account/reset-password`, changePassword);
  }

}
